module.exports = __webpack_public_path__ + "img/63_@2x.01e1cf67.png";